import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import HeatPumpDetail from '../../components/hot_water_system/HeatPumpDetail';
import { createHeatPump } from '../../redux/heat_pump/heat_pump_actions';

class HeatPumpCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.heatPumpDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newHeatPump = this.heatPumpDetail.getWrappedInstance().getWrappedInstance().getHeatPumpData();
    this.props.createHeatPump(newHeatPump);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create heat pump')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HeatPumpDetail
            ref={ref => (this.heatPumpDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="hot-water-heat-pump-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const heatPumpState = state.hotWaterSystem.heatPump;
  return {
    errorMessage: heatPumpState.errorMessage,
    isCreating: heatPumpState.isCreating,
  };
};

const mapDispatchToProps = dispatch => ({
  createHeatPump: heatPump =>
    dispatch(
      createHeatPump(
        heatPump.name,
        heatPump.type_id,
        heatPump.COP,
        heatPump.description || '',
        heatPump.image,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(HeatPumpCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/heat_pump/HeatPumpCreateModal.js